/* AnnMichell 2026 header behaviour: phone drawer, desktop mega menu, search panel (predictive), currency (Kilatech),
   Shopify Inbox chat link. Markup: sections/am-header.liquid + snippets/am-menu.liquid + snippets/am-search-results.liquid.
   No dependencies. Everything is guarded so a missing piece never throws. */
(function () {
  'use strict';
  var d = document, html = d.documentElement, W = window;
  var root = d.querySelector('[data-am26-header]');
  if (!root || root.getAttribute('data-am-menu-ready')) return;
  root.setAttribute('data-am-menu-ready', '1');

  var each = function (list, fn) { Array.prototype.forEach.call(list || [], fn); };
  var MQ = W.matchMedia ? W.matchMedia('(max-width: 989px)') : { matches: W.innerWidth < 990 };
  var FOCUSABLE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]):not([hidden]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  function isShown(el) {
    if (!el || el.hidden) return false;
    if (!(el.offsetWidth || el.offsetHeight || el.getClientRects().length)) return false;
    var cs = W.getComputedStyle(el);
    return cs.visibility !== 'hidden' && cs.display !== 'none';
  }
  function focusables(container) { return Array.prototype.filter.call(container.querySelectorAll(FOCUSABLE), isShown); }
  function focusEl(el) { if (!el) return; try { el.focus({ preventScroll: true }); } catch (e) { el.focus(); } }
  function trapTab(e, list) {
    list = list.filter(Boolean);
    if (e.key !== 'Tab' || !list.length) return;
    var i = list.indexOf(d.activeElement), n;
    e.preventDefault();
    if (e.shiftKey) n = i <= 0 ? list.length - 1 : i - 1;
    else n = (i < 0 || i >= list.length - 1) ? 0 : i + 1;
    focusEl(list[n]);
  }

  /* ---------- scroll lock (no scroll-behind) ---------- */
  var locks = 0, lockY = 0, lockMode = '';
  function lock() {
    if (locks++) return;
    lockY = W.pageYOffset || html.scrollTop || 0;
    if (MQ.matches) {
      lockMode = 'fixed';
      d.body.style.top = (-lockY) + 'px';
      html.classList.add('am-lock-fixed');
    } else {
      lockMode = 'overflow';
      var sw = W.innerWidth - html.clientWidth;
      html.classList.add('am-lock');
      if (sw > 0) d.body.style.paddingRight = sw + 'px';
    }
  }
  function unlock() {
    if (!locks) return;
    if (--locks) return;
    if (lockMode === 'fixed') {
      html.classList.remove('am-lock-fixed');
      d.body.style.top = '';
      W.scrollTo(0, lockY);
    } else {
      html.classList.remove('am-lock');
      d.body.style.paddingRight = '';
    }
    lockMode = '';
  }

  /* ---------- phone drawer ---------- */
  var toggle = root.querySelector('[data-am-menu-toggle]');
  var drawer = d.getElementById('am-menu-drawer');
  var drawerOpen = false, viewOpener = null;

  function showView(key) {
    if (!drawer) return;
    each(drawer.querySelectorAll('[data-am-view]'), function (v) {
      var on = v.getAttribute('data-am-view') === key;
      v.hidden = !on;
      if (on && key === 'root') { v.classList.remove('is-back'); }
    });
    each(drawer.querySelectorAll('[data-am-view-open]'), function (b) {
      b.setAttribute('aria-expanded', b.getAttribute('data-am-view-open') === key ? 'true' : 'false');
    });
    drawer.scrollTop = 0;
  }
  function placeDrawer() {
    if (!drawer || !drawerOpen) return;
    var r = root.getBoundingClientRect();
    drawer.style.top = Math.max(0, Math.round(r.bottom)) + 'px';
  }
  function openDrawer() {
    if (!drawer || !toggle || drawerOpen) return;
    closeSearch(false, true); closeMega(false, true);
    drawerOpen = true;
    lock();
    html.classList.add('am-menu-open');
    showView('root');
    drawer.hidden = false;
    placeDrawer();
    toggle.setAttribute('aria-expanded', 'true');
    toggle.setAttribute('aria-label', 'Close menu');
    var first = drawer.querySelector('.am-drawer__item');
    focusEl(first);
  }
  function closeDrawer(restoreFocus) {
    if (!drawerOpen) return;
    drawerOpen = false;
    drawer.hidden = true;
    html.classList.remove('am-menu-open');
    unlock();
    showView('root');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.setAttribute('aria-label', 'Open menu');
    if (restoreFocus) focusEl(toggle);
  }
  if (toggle && drawer) {
    toggle.addEventListener('click', function (e) {
      e.preventDefault();
      if (drawerOpen) closeDrawer(true); else openDrawer();
    });
    drawer.addEventListener('click', function (e) {
      var t = e.target;
      var openBtn = t.closest('[data-am-view-open]');
      if (openBtn) {
        viewOpener = openBtn;
        showView(openBtn.getAttribute('data-am-view-open'));
        var view = drawer.querySelector('[data-am-view="' + openBtn.getAttribute('data-am-view-open') + '"]');
        focusEl(view && view.querySelector('[data-am-view-back]'));
        return;
      }
      if (t.closest('[data-am-view-back]')) {
        showView('root');
        var rootView = drawer.querySelector('[data-am-view="root"]');
        if (rootView) { rootView.classList.remove('is-back'); void rootView.offsetWidth; rootView.classList.add('is-back'); }
        focusEl(viewOpener);
        return;
      }
      if (t.closest('[data-am-menu-close]')) { closeDrawer(true); return; }
    });
    // any other header control (bag, account, logo) closes the drawer first
    root.addEventListener('click', function (e) {
      if (!drawerOpen) return;
      var c = e.target.closest('a, button');
      if (!c || c === toggle || c.hasAttribute('data-am-search-open')) return;
      closeDrawer(false);
    });
  }

  /* ---------- desktop mega menu ----------
     Motion lives in am-menu.css: .am-in = fade + 8px drop then a 40ms stagger of the columns/tiles,
     .am-swap = moving to another top-level item while open (contents cross-fade, no drop replay),
     .am-out = 150ms fade before the panel is hidden again. */
  var megaBtns = root.querySelectorAll('[data-am-mega-btn]');
  var megaWrap = root.querySelector('[data-am-mega]');
  var nav = root.querySelector('.am-nav');
  var megaOv = null, megaCur = null, megaClosing = null, tOpen = 0, tClose = 0, tMegaHide = 0;
  var OUT_MS = 150, HOVER_OPEN_MS = 80;
  var hoverOK = W.matchMedia ? W.matchMedia('(hover: hover) and (pointer: fine)') : { matches: true };
  function btnFor(key) { return root.querySelector('[data-am-mega-btn="' + key + '"]'); }
  function panelFor(key) { return megaWrap && megaWrap.querySelector('[data-am-mega-panel="' + key + '"]'); }
  function placeMegaOv() { /* the overlay covers the viewport from the top, behind the header (see am-menu.css) */ }
  function finishMegaClose() {
    clearTimeout(tMegaHide);
    megaClosing = null;
    if (megaCur !== null || !megaWrap) return;
    each(megaWrap.querySelectorAll('[data-am-mega-panel]'), function (p) { p.hidden = true; p.classList.remove('am-in', 'am-swap', 'am-out'); });
    html.classList.remove('am-mega-open');
    if (megaOv) { megaOv.hidden = true; megaOv.classList.remove('am-in', 'am-out'); }
  }
  function openMega(key) {
    clearTimeout(tClose); clearTimeout(tOpen);
    if (!megaWrap || megaCur === key || MQ.matches) return;
    if (!panelFor(key)) return;
    closeSearch(false, true);
    var swap = megaCur !== null || megaClosing !== null, fading = megaClosing;
    clearTimeout(tMegaHide); megaClosing = null;
    megaCur = key;
    each(megaWrap.querySelectorAll('[data-am-mega-panel]'), function (p) {
      if (p.getAttribute('data-am-mega-panel') !== key) { p.hidden = true; p.classList.remove('am-in', 'am-swap', 'am-out'); return; }
      if (p === fading) { p.classList.remove('am-out'); return; }   // same panel caught mid-fade: just bring it back
      p.classList.remove('am-in', 'am-swap', 'am-out');
      p.classList.add(swap ? 'am-swap' : 'am-in');
      p.hidden = false;
    });
    each(megaBtns, function (b) { b.setAttribute('aria-expanded', b.getAttribute('data-am-mega-btn') === key ? 'true' : 'false'); });
    html.classList.add('am-mega-open');
    if (!megaOv) {
      megaOv = d.createElement('div');
      megaOv.className = 'am-mega-ov';
      megaOv.setAttribute('aria-hidden', 'true');
      megaOv.hidden = true;
      megaOv.addEventListener('click', function () { closeMega(false); });
      megaOv.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') scheduleClose(120); });
      d.body.appendChild(megaOv);
    }
    if (megaOv.hidden) { megaOv.classList.remove('am-out'); megaOv.classList.add('am-in'); megaOv.hidden = false; }
    else megaOv.classList.remove('am-out');
    placeMegaOv();
  }
  function closeMega(focusBtn, instant) {
    clearTimeout(tOpen); clearTimeout(tClose);
    if (megaCur === null) { if (instant && megaClosing) finishMegaClose(); return; }
    var b = btnFor(megaCur), p = panelFor(megaCur);
    megaCur = null;
    each(megaBtns, function (x) { x.setAttribute('aria-expanded', 'false'); });
    if (instant || !p) { finishMegaClose(); }
    else {
      megaClosing = p;
      p.classList.add('am-out');
      if (megaOv) megaOv.classList.add('am-out');
      clearTimeout(tMegaHide); tMegaHide = setTimeout(finishMegaClose, OUT_MS);
    }
    if (focusBtn && b) focusEl(b);
  }
  function scheduleClose(ms) { clearTimeout(tOpen); clearTimeout(tClose); tClose = setTimeout(function () { closeMega(false); }, ms); }
  each(megaBtns, function (b) {
    var key = b.getAttribute('data-am-mega-btn');
    b.addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'mouse' || !hoverOK.matches) return;
      clearTimeout(tClose); clearTimeout(tOpen);
      tOpen = setTimeout(function () { openMega(key); }, megaCur === null ? HOVER_OPEN_MS : 0);   // hover intent: passing over the nav doesn't flash a panel
    });
    b.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') scheduleClose(220); });
    b.addEventListener('click', function (e) {
      // first activation opens the panel; a second one follows the link
      if (megaCur !== key) { e.preventDefault(); openMega(key); }
    });
    b.addEventListener('keydown', function (e) {
      if (e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); if (megaCur === key) closeMega(false); else openMega(key); }
      else if (e.key === 'ArrowDown') {
        e.preventDefault(); openMega(key);
        var p = panelFor(key); focusEl(p && p.querySelector('a, button'));
      }
    });
  });
  if (megaWrap) {
    megaWrap.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') clearTimeout(tClose); });
    megaWrap.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') scheduleClose(220); });
  }
  if (nav) {
    each(nav.querySelectorAll('a:not([data-am-mega-btn])'), function (a) {
      a.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse' && megaCur !== null) scheduleClose(120); });
    });
  }
  d.addEventListener('focusin', function (e) {
    if (megaCur === null) return;
    if ((nav && nav.contains(e.target)) || (megaWrap && megaWrap.contains(e.target))) return;
    closeMega(false);
  });
  W.addEventListener('scroll', function () { if (megaCur !== null) closeMega(false); }, { passive: true });

  /* ---------- search ----------
     Desktop: the magnifier opens #am-search as a dropdown under the header (fade + drop, then bar / side / results rise),
     closed by the X, Esc, the icon again, or any click outside it. Phones: the full-screen sheet, no motion (unchanged). */
  var head = root.querySelector('[data-am26-head]') || root.querySelector('.am26-head');
  var sPanel = d.getElementById('am-search');
  var sInput = sPanel && sPanel.querySelector('[data-am-search-input]');
  var sBody = sPanel && sPanel.querySelector('[data-am-search-body]');
  var sClear = sPanel && sPanel.querySelector('[data-am-search-clear]');
  var sOpen = false, sOpener = null, sOv = null, sDefault = sBody ? sBody.innerHTML : '', sTimer = 0, sLast = '', sCtrl = null, tSearchHide = 0, tSearchIn = 0;

  function convertPrices() {
    try {
      var K = W.KTCurrency, shopCur = W.shopCurrency || W.shop_currency;
      if (K && K.currentCurrency && shopCur && K.currentCurrency !== shopCur && typeof K.convertAll === 'function') K.convertAll(shopCur, K.currentCurrency);
    } catch (e) {}
  }
  function setResults(htmlStr) { if (!sBody) return; sBody.innerHTML = htmlStr; sBody.classList.remove('is-loading'); }
  function syncClear() { if (sClear && sInput) sClear.hidden = !sInput.value; }
  function runQuery(q) {
    q = (q || '').replace(/^\s+|\s+$/g, '');
    clearTimeout(sTimer);
    syncClear();
    if (!q) { sLast = ''; if (sCtrl) { try { sCtrl.abort(); } catch (e) {} } setResults(sDefault); return; }
    sTimer = setTimeout(function () { fetchResults(q); }, 180);
  }
  function fetchResults(q) {
    if (q === sLast || !W.fetch) return;
    sLast = q;
    if (sCtrl) { try { sCtrl.abort(); } catch (e) {} }
    sCtrl = W.AbortController ? new AbortController() : null;
    var base = (W.Shopify && W.Shopify.routes && W.Shopify.routes.root) || '/';
    var url = base + 'search/suggest?q=' + encodeURIComponent(q) +
      '&resources%5Btype%5D=product%2Ccollection&resources%5Blimit%5D=10&resources%5Blimit_scope%5D=each' +
      '&resources%5Boptions%5D%5Bunavailable_products%5D=last' +
      '&resources%5Boptions%5D%5Bfields%5D=title%2Cproduct_type%2Cvariants.sku%2Cvendor%2Ctag&section_id=am-header';
    if (sBody) sBody.classList.add('is-loading');
    W.fetch(url, sCtrl ? { signal: sCtrl.signal, credentials: 'same-origin' } : { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('search ' + r.status); return r.text(); })
      .then(function (t) {
        if (q !== sLast) return;
        var doc = new DOMParser().parseFromString(t, 'text/html');
        var res = doc.getElementById('am-search-results');
        if (res) { setResults(res.outerHTML); convertPrices(); }
        else if (sBody) sBody.classList.remove('is-loading');
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        sLast = '';
        if (sBody) sBody.classList.remove('is-loading');
      });
  }
  function placeSearch() {
    if (!sPanel) return;
    if (MQ.matches || !head) { sPanel.style.maxHeight = ''; return; }
    var b = head.getBoundingClientRect().bottom;
    sPanel.style.maxHeight = Math.max(260, Math.floor(W.innerHeight - Math.max(0, b) - 1)) + 'px';
  }
  function finishSearchClose() {
    clearTimeout(tSearchHide);
    if (sOpen || !sPanel) return;
    sPanel.hidden = true;
    sPanel.classList.remove('am-in', 'am-out');
    sPanel.style.maxHeight = '';
    if (sOv) { sOv.hidden = true; sOv.classList.remove('am-in', 'am-out'); }
    html.classList.remove('am-search-open');
  }
  function openSearch(opener, text) {
    if (!sPanel || sOpen) return;
    closeDrawer(false); closeMega(false, true);
    var desk = !MQ.matches, fading = !sPanel.hidden && sPanel.classList.contains('am-out');
    clearTimeout(tSearchHide); clearTimeout(tSearchIn);
    sOpen = true; sOpener = opener || null;
    sPanel.classList.remove('am-out');
    if (!fading) {
      sPanel.classList.remove('am-in');
      if (desk) sPanel.classList.add('am-in');
      sPanel.hidden = false;
    }
    // the entrance plays once; results that arrive later just swap in
    tSearchIn = setTimeout(function () { sPanel.classList.remove('am-in'); }, 700);
    if (!sOv) {
      sOv = d.createElement('div');
      sOv.className = 'am-search-ov';
      sOv.setAttribute('aria-hidden', 'true');
      sOv.hidden = true;
      sOv.addEventListener('click', function () { closeSearch(false); });
      d.body.appendChild(sOv);
    }
    sOv.classList.remove('am-out');
    if (sOv.hidden) { if (desk) sOv.classList.add('am-in'); sOv.hidden = false; }
    html.classList.add('am-search-open');
    lock();
    placeSearch();
    each(root.querySelectorAll('[data-am-search-open]'), function (o) { o.setAttribute('aria-expanded', 'true'); });
    if (sInput) {
      if (typeof text === 'string' && text && !sInput.value) sInput.value = text;
      focusEl(sInput);
      try { var n = sInput.value.length; sInput.setSelectionRange(n, n); } catch (e) {}
      runQuery(sInput.value);
    }
  }
  function closeSearch(restoreFocus, instant) {
    if (!sOpen) { if (instant) finishSearchClose(); return; }
    sOpen = false;
    clearTimeout(tSearchIn);
    unlock();
    each(root.querySelectorAll('[data-am-search-open]'), function (o) { o.setAttribute('aria-expanded', 'false'); });
    if (instant || MQ.matches) finishSearchClose();
    else {
      sPanel.classList.remove('am-in');
      sPanel.classList.add('am-out');
      if (sOv) sOv.classList.add('am-out');
      clearTimeout(tSearchHide); tSearchHide = setTimeout(finishSearchClose, OUT_MS);
    }
    if (restoreFocus && sOpener) focusEl(sOpener);
  }
  if (sPanel && sInput) {
    each(root.querySelectorAll('[data-am-search-open]'), function (o) {
      o.addEventListener('click', function (e) { e.preventDefault(); if (sOpen) closeSearch(true); else openSearch(o); });
    });
    sInput.addEventListener('input', function () { runQuery(sInput.value); });
    if (sClear) sClear.addEventListener('click', function () { sInput.value = ''; runQuery(''); focusEl(sInput); });
    var sClose = sPanel.querySelector('[data-am-search-close]');
    if (sClose) sClose.addEventListener('click', function () { closeSearch(true); });
    // desktop: a press anywhere outside the dropdown (header included) closes it; the icon itself toggles
    d.addEventListener('pointerdown', function (e) {
      if (!sOpen || MQ.matches) return;
      var t = e.target;
      if (!t || sPanel.contains(t) || (t.closest && t.closest('[data-am-search-open]'))) return;
      closeSearch(false);
    }, true);
  }

  /* ---------- keyboard: Esc + focus traps ---------- */
  d.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      if (sOpen) { e.preventDefault(); closeSearch(true); }
      else if (drawerOpen) { e.preventDefault(); closeDrawer(true); }
      else if (megaCur !== null) { e.preventDefault(); closeMega(true); }
      return;
    }
    if (e.key !== 'Tab') return;
    if (sOpen) trapTab(e, focusables(sPanel));
    else if (drawerOpen) trapTab(e, [toggle].concat(focusables(drawer)));
  });

  /* ---------- layout changes ---------- */
  /* desktop nav: one row (logo | nav | icons) unless the links don't fit, then the nav drops to its own row */
  var rowNav = head && head.querySelector('.am26-head__row > .am-nav');
  function fitNav() {
    if (!head || !rowNav) return;
    head.classList.remove('am26-head--2row');
    if (MQ.matches) return;
    if (rowNav.scrollWidth > rowNav.clientWidth + 1) head.classList.add('am26-head--2row');
  }
  fitNav();
  try { if (d.fonts && d.fonts.ready) d.fonts.ready.then(fitNav); } catch (e) {}
  W.addEventListener('load', fitNav);

  function onMQ() {
    if (!MQ.matches && drawerOpen) closeDrawer(false);
    if (MQ.matches && megaCur !== null) closeMega(false, true);
    if (sOpen) closeSearch(false, true);
    fitNav();
  }
  if (MQ.addEventListener) MQ.addEventListener('change', onMQ); else if (MQ.addListener) MQ.addListener(onMQ);
  var rzRaf = 0;
  W.addEventListener('resize', function () {
    placeDrawer(); placeMegaOv(); placeSearch();
    if (rzRaf) return;
    rzRaf = (W.requestAnimationFrame || setTimeout)(function () { rzRaf = 0; fitNav(); });
  });
  W.addEventListener('pageshow', function (e) { if (e.persisted) { closeDrawer(false); closeMega(false, true); closeSearch(false, true); } });

  /* ---------- Shopify Inbox chat ("Chat with a sizing expert") ---------- */
  function chatEl() { return d.querySelector('shopify-chat'); }
  function chatButton(c) {
    try { return c && c.shadowRoot && (c.shadowRoot.querySelector('button[part~="activator"]') || c.shadowRoot.querySelector('button.activator')); } catch (e) { return null; }
  }
  function setChatVisible(on) {
    each(d.querySelectorAll('[data-am-chat-row], [data-am-chat-wrap]'), function (el) { el.hidden = !on; });
    each(d.querySelectorAll('[data-am-chat-fallback]'), function (el) { el.hidden = on; });
  }
  function openChat() {
    closeDrawer(false); closeMega(false, true); closeSearch(false, true);
    var c = chatEl();
    if (!c) {
      var fb = d.querySelector('[data-am-chat-fallback]');
      W.location.href = (fb && fb.getAttribute('href')) || '/pages/contact';
      return;
    }
    var b = chatButton(c);
    if (b) { if (b.getAttribute('aria-expanded') !== 'true') b.click(); return; }
    // no launcher button = the chat window is already open
    if (typeof c.open === 'function') { try { c.open(); } catch (e) {} }
  }
  d.addEventListener('click', function (e) {
    var t = e.target.closest && e.target.closest('[data-am-chat]');
    if (!t) return;
    e.preventDefault(); openChat();
  });
  (function waitChat(n) {
    var c = chatEl();
    if (c && (chatButton(c) || typeof c.open === 'function')) { setChatVisible(true); return; }
    if (n > 0) setTimeout(function () { waitChat(n - 1); }, 500);
  })(30);

  /* ---------- bag: open the Rebuy side cart, never the /cart page ----------
     Rebuy binds its own click on a[href="/cart"] only once its SmartCart script has loaded (about 1-2 s after the page,
     much later on a slow phone); a tap before that used to land on /cart. So the header bag always prevents the
     navigation and opens Rebuy.SmartCart.show() itself, waiting up to 1.5 s for Rebuy; /cart only if it never loads.
     Modifier clicks (new tab / window) still go to /cart. */
  function smartCart() {
    // ready = the API exists AND its drawer is in the page (on phones SmartCart.show exists ~250 ms before #rebuy-cart,
    // and a show() in that gap does nothing)
    var R = W.Rebuy, sc = R && R.SmartCart;
    return sc && typeof sc.show === 'function' && d.getElementById('rebuy-cart') && d.querySelector('.rebuy-cart__flyout') ? sc : null;
  }
  function cartShown() {
    // Rebuy's own flag only: Ella's old jQuery in layout/theme.liquid adds body.rebuy-cart-visible on every bag click,
    // whether or not the cart actually opened
    var c = d.getElementById('rebuy-cart');
    return !!(c && c.classList.contains('is-visible'));
  }
  each(root.querySelectorAll('a.navUser-action.cart'), function (a) {
    a.addEventListener('click', function (e) {
      if (e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      closeMega(false, true); closeSearch(false, true);
      var href = a.getAttribute('href') || '/cart', t0 = Date.now(), tries = 0;
      function giveUp() { if (!cartShown()) W.location.href = href; }
      // run after every other click handler on the link (Rebuy's own one opens the cart once it is bound)
      setTimeout(function tryOpen() {
        if (cartShown()) return;
        var sc = smartCart();
        if (sc) {
          try { sc.show(); } catch (err) {}
          // confirm it really opened; one retry, then /cart
          setTimeout(function () { if (cartShown()) return; if (++tries < 2) tryOpen(); else giveUp(); }, 400);
          return;
        }
        if (Date.now() - t0 >= 1500) { giveUp(); return; }
        setTimeout(tryOpen, 100);
      }, 0);
    });
  });

  /* ---------- bag count: keep the header pill in step with the real cart ----------
     The product form / Rebuy add through fetch without a theme event, so watch the cart requests themselves
     (PerformanceObserver = read-only, no fetch patching) and re-read /cart.js. */
  var cartTimer = 0;
  function setCartCount(n) {
    if (typeof n !== 'number' || isNaN(n)) return;
    each(root.querySelectorAll('[data-cart-count]'), function (el) { el.textContent = n; el.setAttribute('data-count', n); });
  }
  function refreshCart() {
    if (!W.fetch) return;
    var base = (W.Shopify && W.Shopify.routes && W.Shopify.routes.root) || '/';
    W.fetch(base + 'cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) { if (c) setCartCount(c.item_count); })
      .catch(function () {});
  }
  function cartSoon(ms) { clearTimeout(cartTimer); cartTimer = setTimeout(refreshCart, ms || 300); }
  var CART_RE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  try {
    if (W.PerformanceObserver) {
      new W.PerformanceObserver(function (list) {
        list.getEntries().forEach(function (e) { if (CART_RE.test(e.name)) cartSoon(250); });
      }).observe({ type: 'resource', buffered: false });
    }
  } catch (e) {}
  ['cart:updated', 'cart:refresh', 'rebuy:cart.change', 'rebuy:cart.add', 'rebuy:smartcart.hide'].forEach(function (ev) {
    d.addEventListener(ev, function () { cartSoon(250); });
  });
  W.addEventListener('pageshow', function (e) { if (e.persisted) refreshCart(); });

  /* ---------- currency (Kilatech Currency Converter) ---------- */
  var curNodes = d.querySelectorAll('[data-am-cur]');
  function curSymbol(K, c) {
    try {
      var f = ((K.moneyFormats || {})[c] || {}).money_format || '';
      var t = d.createElement('textarea');
      t.innerHTML = f.replace(/\{\{[^}]*\}\}/g, '');
      return t.value.replace(/^\s+|\s+$/g, '');
    } catch (e) { return ''; }
  }
  function curText(K, c) { var s = curSymbol(K, c); return c + (s && s !== c ? ' ' + s : ''); }
  function curRefresh() {
    var K = W.KTCurrency; if (!K || !K.currentCurrency) return;
    var c = K.currentCurrency, local = null;
    try { local = W.localStorage.getItem('local_currency'); } catch (e) {}
    each(curNodes, function (n) {
      var l = n.querySelector('[data-am-cur-label]'); if (l) l.textContent = curText(K, c);
      var s = n.querySelector('[data-am-cur-select]'); if (s && s.value !== c) s.value = c;
      var a = n.querySelector('[data-am-cur-auto]'); if (a) a.hidden = !(local && local === c);
    });
  }
  function curSetup(K, D) {
    var list = (D.currencies || []).slice();
    var local = null; try { local = W.localStorage.getItem('local_currency'); } catch (e) {}
    [local, K.currentCurrency].forEach(function (c) { if (c && list.indexOf(c) < 0) list.unshift(c); });
    var opts = list.map(function (c) { return '<option value="' + c + '">' + curText(K, c).replace(/</g, '&lt;') + '</option>'; }).join('');
    each(curNodes, function (n) {
      var s = n.querySelector('[data-am-cur-select]'); if (!s) return;
      s.innerHTML = opts; s.value = K.currentCurrency; s.hidden = false;
      n.classList.add('is-live');
      s.addEventListener('change', function () {
        var v = s.value, K2 = W.KTCurrency, D2 = W.dropdown_CC_KT;
        try { if (v && K2 && v !== K2.currentCurrency) { K2.convertAll(K2.currentCurrency, v); if (D2 && D2.setValue) D2.setValue(v); } } catch (e) {}
        curRefresh();
      });
    });
    if (typeof D.setValue === 'function' && !D.__amWrapped) {
      var orig = D.setValue;
      D.setValue = function () { var r = orig.apply(this, arguments); try { curRefresh(); } catch (e) {} return r; };
      D.__amWrapped = true;
    }
    curRefresh();
  }
  if (curNodes.length) {
    (function waitKT(n) {
      var K = W.KTCurrency, D = W.dropdown_CC_KT;
      if (K && K.currentCurrency && typeof K.convertAll === 'function' && D && D.currencies && D.currencies.length) { curSetup(K, D); return; }
      if (n > 0) setTimeout(function () { waitKT(n - 1); }, 300);
    })(40);
  }
})();
